import { globalEntitlements } from './globalEntitlements';

// Service name constants - these are what you purchase
const MONTHLY_BASIC = 'zb_tax_advice';
const MONTHLY_BIZTAX = 'zb_tax_advice_biztax_prep';

// Entitlement constants - these are what come back after purchase
const TAX_UNLIMITED_ADVICE_ENTITLEMENT = 'tax_unlimited_advice';
const TAX_ANNUAL_FILING_ENTITLEMENT = 'tax_annual_filing';

/**
 * Gets the appropriate Tax Advice buy button configuration using globalEntitlements builder
 * @param {...any} args
 * @returns {object} - Buy button configuration object
 */
export const getTaxAdviceBuyButtonConfig = (...args) => {
  const service = args[1];
  const serviceToButtonText = {
    [MONTHLY_BASIC]: 'productPage.taxAdvice.buyBox.button1Label',
    [MONTHLY_BIZTAX]: 'productPage.taxAdvice.buyBox.button2Label'
  };

  const ctaText = serviceToButtonText[service] || serviceToButtonText[MONTHLY_BASIC];

  return globalEntitlements({
    ctaText
  }).blockedByRelatedServices([TAX_UNLIMITED_ADVICE_ENTITLEMENT, TAX_ANNUAL_FILING_ENTITLEMENT])
    .currentProductNotPurchased()
    .build()(...args);
};
